import { useNavigate, useLocation } from "react-router-dom";
import I18n from "i18n-js";
import { useScale, usePlaySound } from "common/utils";
import { IconBack } from "features/user/assets";

export const BackBtn = () => {
  const { scale } = useScale();
  const navigate = useNavigate();
  const location = useLocation();
  const playSound = usePlaySound();

  const handleBack = () => {
    playSound();

    switch (location.pathname) {
      case "/auth/login":
        navigate("/", { replace: true });
        break;
      case "/auth/email-login":
        navigate("/auth/login", { replace: true });
        break;
      case "/auth/password-reset":
        navigate("/auth/email-login", { replace: true });
        break;
      case "/auth/register":
        navigate("/", { replace: true });
        break;
      case "/auth/email-register":
        navigate("/auth/register", { replace: true });
        break;
      default:
        navigate("/", { replace: true });
        break;
    }
  };

  return (
    <div
      className="flex-row-el absolute left-0 z-[9998]"
      style={{ top: 4 * scale }}
    >
      <div
        className="flex-row-el items-center justify-start"
        style={{ width: 170 * scale, height: 102 * scale }}
      >
        <div
          className="flex-row-view items-center justify-start w-[96px] h-[72px] origin-left"
          style={{ transform: `scale(${scale})` }}
        >
          <div
            className="flex-col-center w-[96px] h-[72px] cursor-pointer active:opacity-70 bg-brown-100"
            onClick={handleBack}
          >
            <div className="flex-col-center w-[32px] h-[32px] mb-1">
              <IconBack />
            </div>

            <p className="text text-white !text-[16px]">
              {I18n.t("MSG_BACK_BTN")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
